import React from "react";

import { useTranslation } from "react-i18next";
import { AuthorityCustomer } from "../AuthorityCustomer";
import "./styles.less";

export const AuthorityQuestion = (props) => {
  const { t } = useTranslation();
  const cards = [
    {
      mode: "small",
      title: t("authority.question.card1.title"),
      lists: [
        {
          icon: "authority-default-icon1.png",
          title: t("authority.question.card1.item1.title"),
          subtitle: t("authority.question.card1.item1.descript"),
        },
        {
          icon: "authority-default-icon2.png",
          title: t("authority.question.card1.item2.title"),
          subtitle: t("authority.question.card1.item2.descript"),
        },
        {
          icon: "authority-default-icon3.png",
          title: t("authority.question.card1.item3.title"),
          subtitle: t("authority.question.card1.item3.descript"),
        },
        {
          icon: "authority-default-icon4.png",
          title: t("authority.question.card1.item4.title"),
          subtitle: t("authority.question.card1.item4.descript"),
        },
      ],
    },
    {
      mode: "large",
      title: t("authority.question.card2.title"),
      lists: [
        {
          icon: "authority-icon1.png",
          title: t("authority.question.card2.item1.title"),
          subtitle: t("authority.question.card2.item1.descript"),
        },
        {
          icon: "authority-icon2.png",
          title: t("authority.question.card2.item2.title"),
          subtitle: t("authority.question.card2.item2.descript"),
        },
        {
          icon: "authority-icon3.png",
          title: t("authority.question.card2.item3.title"),
          subtitle: t("authority.question.card2.item3.descript"),
        },
        {
          icon: "authority-icon4.png",
          title: t("authority.question.card2.item4.title"),
          subtitle: t("authority.question.card2.item4.descript"),
        },
      ],
    },
  ];
  return (
    <div className="authority-question-warp">
      <section className="authority-question">
        <div className="inner">
          <div className="title">{t("authority.question.title")}</div>
          <div className="authority-card-warp">
            {cards.map((card, index) => (
              <div className={`authority-card ${card.mode}`}>
                <div className="authority-card-title">{card.title}</div>
                <div className="authority-card-content">
                  {card.lists.map((item) => (
                    <div className="card-content-item">
                      <div className="item-title">
                        <span className="item-icon">
                          <img
                            src={`//files.authing.co/authing-website/${item.icon}`}
                            alt="authing"
                          />
                        </span>
                        <span>{item.title}</span>
                      </div>
                      <div className="item-subtitle">{item.subtitle}</div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <AuthorityCustomer></AuthorityCustomer>
    </div>
  );
};
